import { render, staticRenderFns } from "./HotelInfoAdd.vue?vue&type=template&id=74aaf96c&"
import script from "./HotelInfoAdd.vue?vue&type=script&lang=ts&"
export * from "./HotelInfoAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports